const setPlanetIconStyles = (
  icon: HTMLElement | null,
  offset: number,
  addOffset: number = 0
) => {
  if (!icon) return;

  const totalOffset =
    offset + addOffset > 100 ? offset + addOffset - 100 : offset + addOffset;

  // Change offset-distance css property
  icon?.style.setProperty("offset-distance", `${totalOffset}%`);

  let scaleValue = 1;

  if (totalOffset <= 25) {
    scaleValue = 1 - totalOffset * 0.01;
  } else if (totalOffset <= 50) {
    scaleValue = 0.75 + (totalOffset - 25) * 0.01;
  } else if (totalOffset <= 75) {
    scaleValue = 1 + (totalOffset - 50) * 0.01;
  } else {
    scaleValue = 1.25 - (totalOffset - 75) * 0.01;
  }

  icon?.style.setProperty("transform", `scale(${scaleValue})`);
  icon?.style.setProperty("filter", `brightness(${Math.min(scaleValue, 1)})`);
  icon?.style.setProperty("z-index", `${totalOffset > 34 ? 3 : 0}`);
  icon?.style.setProperty("opacity", `${Math.min(scaleValue, 1)}`);
};

export default setPlanetIconStyles;
